import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
// import { Form } from "formik";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import { formatarData } from "../../../../components/Formatters/DateTime";
import removeHTML from "../../ProrrogacaoOS/components/RemoveHTML";

// import useSetGuard from "../../../../hooks/useSetGuard";

const dataPedidoText = (context) => {
  if (context && formatarData(context.dataPedidoPror, "yyyy") > 1990) {
    return formatarData(context.dataPedidoPror);
  }

  return null;
};

const expiracaoText = (context) => {
  if (context?.diasExpirar >= 0) {
    return context?.diasExpirar;
  }
  if (context?.diasExpirar < 0) {
    return "Expirada";
  }
  return null;
};

const useProrrogacaoOs = ({ formik }) => {
  const [isHidden, setIsHidden] = useState(true);
  const [isHiddenInputNo, setIsHiddenInputNo] = useState(true);
  const [respostaProrrogar, setRespostaProrrogar] = useState(null);

  const [showProrrogarOsConfirm, setShowProrrogarOsConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const {
    request: requestProrrogar,
    data: dataProrrogar,
    errors: errorProrrogar,
    isLoading: isLoadingPror,
  } = useApiClient();

  useEffect(() => {
    if (!dataProrrogar && !errorProrrogar) return;
    if (dataProrrogar) {
      toast.success(dataProrrogar.result);
      document.location.reload(true);
    }
    setShowProrrogarOsConfirm({ show: false });
  }, [dataProrrogar, errorProrrogar, setShowProrrogarOsConfirm, setIsHidden, setIsHiddenInputNo]);

  function getProrrogacao(sqAcaoFiscal, qtDiasPror, justificativa, sqPedidoProrrogacao, sqOrdemServico, prorrogar) {
    if (prorrogar !== null) {
      if (prorrogar === true) {
        if (qtDiasPror !== "") {
          requestProrrogar(apiRoutes.fiscalizacao.prorrogacaoos.prorrogarOs, {
            sequencialAcaoFiscal: sqAcaoFiscal,
            situacaoProrroga: "S",
            qtDiasProrroga: qtDiasPror,
            txProrroga: null,
            sequencialPedidoProrrogacao: sqPedidoProrrogacao,
            assinarProrrogacaoOS: true,
            sequencialOrdemServico: sqOrdemServico,
            nomeAtividade: "Diretor Prorroga a OS e Gera o Termo de Prorrogação de OS para Ciência Pessoal - DTE",
          });
        } else {
          toast.warning("Favor informar a quantidade de dias de prorrogação!");
        }
      } else if (prorrogar === false) {
        if (
          justificativa !== "" &&
          justificativa !== null &&
          justificativa !== undefined &&
          justificativa !== "<p><br></p>"
        ) {
          requestProrrogar(apiRoutes.fiscalizacao.prorrogacaoos.prorrogarOs, {
            sequencialAcaoFiscal: sqAcaoFiscal,
            situacaoProrroga: "N",
            qtDiasProrroga: null,
            txProrroga: justificativa,
            sequencialPedidoProrrogacao: sqPedidoProrrogacao,
            assinarProrrogacaoOS: true,
            sequencialOrdemServico: sqOrdemServico,
            nomeAtividade: "Diretor justifica a não prorrogação da OS",
          });
        } else {
          toast.warning("Favor informar a justificativa!");
        }
      }
    } else {
      toast.warning("Favor selecionar uma das opções acima!");
    }

    setIsHidden(true);
    setIsHiddenInputNo(true);
    setRespostaProrrogar(null);
  }

  const prorrogacaoOsModal = (
    <>
      <FormAlert formik={formik} data={dataProrrogar} errors={errorProrrogar} isLoading={isLoadingPror} dismissable />
      <EfisModal
        show={showProrrogarOsConfirm.show}
        title="Prorrogação da OS"
        body={showProrrogarOsConfirm.body}
        primaryLabel="Assinar"
        loadingConfirmationAction={isLoadingPror}
        closeHandler={() => {
          setShowProrrogarOsConfirm({ show: false });
          setIsHidden(true);
          setIsHiddenInputNo(true);
        }}
        confirmationHandler={() => {
          getProrrogacao(
            showProrrogarOsConfirm.context.sqAcaoFiscal,
            document.getElementsByName("qtDiasProrroga")[0].value,
            document.getElementsByName("justificativaPror")[0].value,
            showProrrogarOsConfirm.context.sqPedidoProrrogacao,
            showProrrogarOsConfirm.context.codigo,
            respostaProrrogar,
          );
        }}
      >
        <strong>OS Nº </strong>
        &nbsp;
        {showProrrogarOsConfirm.context?.codigo}
        <br />
        <strong>Dias para Expirar: </strong>
        {expiracaoText(showProrrogarOsConfirm.context)}
        <br />
        <strong>
          Justificativa do pedido em &nbsp;
          {dataPedidoText(showProrrogarOsConfirm.context)}:
        </strong>
        <p>{removeHTML(showProrrogarOsConfirm.context?.txJustificativaPror)}</p>
        <b>Análise do Gestor</b>
        <br />
        <input
          name="radioProrrogar"
          onFocus={() => setIsHidden(false)}
          onChange={() => {
            setIsHiddenInputNo(true);
            setRespostaProrrogar(false);
          }}
          type="radio"
          value="N"
        />
        &nbsp; Não Prorrogar
        <br />
        <span hidden={isHidden}>
          Justificativa:
          <br />
          <textarea name="justificativaPror" rows="4" cols="50" resize="none" />
        </span>
        <Row>
          <Col xs={8}>
            <input
              name="radioProrrogar"
              onFocus={() => setIsHiddenInputNo(false)}
              onChange={() => {
                setIsHidden(true);
                setRespostaProrrogar(true);
              }}
              type="radio"
              value="S"
            />
            &nbsp; Prorrogar por:
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span hidden={isHiddenInputNo}>
              <input type="number" min="0" name="qtDiasProrroga" /> dias
            </span>
          </Col>
        </Row>
      </EfisModal>
    </>
  );

  return {
    prorrogacaoOsModal,
    setShowProrrogarOsConfirm,
  };
};

export default useProrrogacaoOs;
